import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Gallery from '../components/Gallery';
import QuoteForm from '../components/QuoteForm';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Toaster } from '../components/ui/sonner';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Gallery />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LandingPage;
